export default __webpack_public_path__ + "static/media/botoes_genericos_04.8f9dab8a.mp3";